/* Автоматически генерируемый файл */
import { cnTheme, type Theme } from '@direct-frontend/components';

import { themeSizeTokens } from './themeSizeTokens';

import './light/color.css';
import './dark/color.css';
import './root.css';

export const yastoreLightTheme: Theme = {
    main: cnTheme({ yastore: true, color: 'light' }),
    inverted: cnTheme({ yastore: true, color: 'dark' }),
    root: cnTheme({ yastore: true, root: true }),
    sizeTokens: themeSizeTokens,
};

export const yastoreDarkTheme: Theme = {
    main: cnTheme({ yastore: true, color: 'dark' }),
    inverted: cnTheme({ yastore: true, color: 'light' }),
    root: cnTheme({ yastore: true, root: true }),
    sizeTokens: themeSizeTokens,
};
